import styled from 'styled-components';

import logoIcon from '~/assets/icons/logo.png';
import usersIcon from '~/assets/icons/users_three.svg';

import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	position: absolute;
	top: 30px;
	left: 30px;
	display: flex;
	align-items: center;
	gap: 20px;
	user-select: none;
	pointer-events: none;
`;

const StyledServerContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
	height: 40px;
	padding: 0 10px;
	border-radius: 10px;
	background-color: rgba(17, 19, 20, 0.95);
	border: 1px solid rgba(255, 255, 255, 0.1);
`;

const StyledLogo = styled.img.attrs({ src: logoIcon })`
	width: 20px;
	height: 20px;
`;

const StyledDivider = styled.div`
	width: 1px;
	height: 20px;
	background-color: rgba(255, 255, 255, 0.1);
`;

const StyledBonusDivider = styled.div`
	width: 2px;
	height: 20px;
	margin-left: -1px;
	background: linear-gradient(
		90deg,
		rgba(255, 255, 255, 0.3) 50%,
		rgba(0, 0, 0, 0.35) 50%
	);
`;

const StyledBonusContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
	height: 34px;
	margin-left: -8px;
	padding: 0 10px 0 8px;
	border-radius: 7px;
	background-color: #eb1818;

	${Text} {
		font-weight: 700;
		font-size: 18px;
		color: #ffffff;
	}
`;

const StyledOnlineContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;

	${Text} {
		font-weight: 700;
		font-size: 14px;
		color: #ffffff;
	}
`;

const StyledOnlineIcon = styled.img.attrs({ src: usersIcon })`
	width: 14px;
	height: 14px;
`;

export {
	StyledBonusContainer,
	StyledBonusDivider,
	StyledContainer,
	StyledDivider,
	StyledLogo,
	StyledOnlineContainer,
	StyledOnlineIcon,
	StyledServerContainer,
};
